module.exports = __webpack_public_path__ + "img/preview-lg.3ba461e6.png";